import api from './index'

export function getCategories() {
  return api.get('/api/v1/categories')
}
